<script>
  import {
    VTab
  } from 'vuetify/lib'
  export default {
    name: 'wh-tab',
    extends: VTab
  };
</script>